module.exports = __webpack_public_path__ + "static/boop-fd10b47d640bc257c5128df705f12cb5.gif";